export const transition = (isCollapse: boolean) => `
              opacity: ${isCollapse ? 0 : 1};
              transform: translateX(${isCollapse ? -20 : 0}px);
              transition: all ${isCollapse ? '1s' : '0.5s'} ease-in-out;
`;
